import { BackgroundBlur, LoaderWrapper } from "@/globalStyles";
import { CircularProgress } from "@mui/material";

export const Loader = ({ isLoading = true }) => isLoading ? (
  <LoaderWrapper>
    <BackgroundBlur />
    <CircularProgress size={80} thickness={5} sx={{ color: "#fff" }} disableShrink />
  </LoaderWrapper>
) : null;
